import { menuselect, getrouteparams } from "@/constant/menuselect";
let str = getrouteparams();
export const config = {
  title: "预算·报销·专项·合同",
  headerInfo:
    "本章节系统性介绍了包括：全面预算管理、费用报销管理、专项经费管理、合同管理在内的多项医院智慧运营管理系统模块。",
  headerImg: require("@/assets/images/bascm/headerimg.png"),
  activeTitle: str,
  activeSubTitle: str,

  navList: [
    {
      name: "预算·报销·专项·合同",
      children: menuselect(),
    },
    {
      name: "全面预算管理",
      desc: "全面预算管理的关键点在于战略规划、业务计划和财务预算之间的三位一体整合，通过战略规划定义和明确具体的整体发展规划和关键指标要求，然后通过业务计划的各科室编制和整体管控制定出各科室认可、可以实现战略目标的业务计划，最后通过业务和财务的转换逻辑将业务计划分解细化和转换为财务预算。全面预算编制的基础是统一整合的、业财一体的HRP系统，通过HRP系统贯穿所有运营管理领域和业务流程后，方可形成业务计划向财务预算的转换逻辑和规则。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/bascm/1082one1.png"),
        },
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/bascm/Group 1083one.png"),
        },
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/bascm/Group 1084one.png"),
        },
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/bascm/Frame 792one.png"),
        },
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/bascm/Frame 793one.png"),
        },
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/bascm/Frame 794one.png"),
        },
      ],
    },
    {
      name: "费用报销管理",
      desc: "建立全院级报销业务平台，通过 PC 端及手机端进行系统接入，以 OCR 等新技术促进报销业务全流程、报销场景全覆盖、管控手段深度融合的报销管理新模式。打通报销业务从费用申请 --预算关联（与预算系统对接）--票务预订 -- 消费记录-- 报销单据 -- 主管审批 -- 出纳支付 -- 财务记账的报销业务全过程。将报销管理制度嵌入到系统中并与预算管理系统集成，报销业务受预算管控，与财务系统集成支付完成后自动生成相关凭证。从而使医院报销业务在信息系统中制度化、流程化、表单化，以实现报销费用控制的闭环管理。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/bascm/Frame 1124two.png"),
        },
        {
          title: "产品优势",
          desc: " ",
          img: require("@/assets/images/bascm/Frame 1087two.png"),
        },
        {
          title: "应用价值",
          desc: "打通消费-报销-入账全流程 员工可移动端报销，简单快速的报销体验，支持医院专项经费等各种报销类型；管理者及时审批单据，掌握开支，实现高效的可视化管理；与财务总账系统集成，费用数据审批后自动生成财务凭证数据",
          img: require("@/assets/images/bascm/Frame 1088two.png"),
        },
        {
          title: "",
          desc: "费用实时控制中心 动态展示医院费用支出汇总，支持按各经费来源分开查看 实现高效的可视化管理； 与财务总账系统集成，费用数据审批后自动生成财务凭证数据",
          img: require("@/assets/images/bascm/Frame 1089two.png"),
        },
        {
          title: "",
          desc: "强化费用管理制度，规范发票/单据审核，优化报销场景",
          img: require("@/assets/images/bascm/Frame 1090two.png"),
        },
      ],
    },

    {
      name: "专项经费管理",
      desc: "专项经费管理是以医院实际业务为基础，结合管理要求，实现一体化管理流程，规范医院专项经费及过程管理，涵盖了专项经费从项目立项、预算编制、资金上账、经费支出到项目结题等整个过程。系统做到了经费支出过程可控，费用花销核算清楚，建立从项目/课题建立，到过程管理，到项目结题的全过程管理，建立在线经费卡，实时归集经费收支情况。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/bascm/Group 647three.png"),
        },
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/bascm/Group 1091three.png"),
        },
        {
          title: "建立从项目/课题建立，到过程管理，到项目结题的全过程管理",
          desc: " ",
          img: require("@/assets/images/bascm/Group 662three.png"),
        },
        {
          title: "建立从项目/课题建立，到过程管理，到项目结题的全过程管理",
          desc: " ",
          img: require("@/assets/images/bascm/Frame 1093three.png"),
        },
        {
          title: "应用价值",
          desc: `高效透明的专项经费管理平台，打通专项经费从立项建卡-经费入账/支出-专项结题的全流程     支持灵活拓展，对接多种平台`,
          img: require("@/assets/images/bascm/Group 663three.png"),
        },
      ],
    },
    {
      name: "合同管理",
      desc: "通过院级合同管理平台的建立，实现合同管理全流程、多属性、资料全归集的目标，使合同管理业务处理完全符合财务内部控制要求。通过系统对合同业务进行自动控制或提供参考，将合同录入、保存、审批、生效、变更、冻结等关键动作统一在系统内实现管理，并提供合同的收付款处理功能。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/bascm/Group 688four.png"),
        },
        {
          title: "应用价值",
          desc: " ",
          img: require("@/assets/images/bascm/Group 690four.png"),
        },
        {
          title: "产品功能",
          desc: " ",
          img: require("@/assets/images/bascm/Group 687four.png"),
        },
      ],
    },
  ],
};
